// src/api/axios.js
import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// Automatically attach token to every request
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// AUTH APIs
export const signup = (data) => API.post("/api/auth/signup", data);
export const login = (data) => API.post("/api/auth/login", data);

// ✅ FORGOT PASSWORD FLOW
export const forgotPassword = (email) =>
  API.post("/api/auth/forgot-password", { email });

export const verifyOtp = (email, otp) =>
  API.post("/api/auth/verify-otp", { email, otp });

export const resetPassword = (email, otp, newPassword) =>
  API.post("/api/auth/reset-password", { email, otp, newPassword });

// TEMPLATE APIs
export const getTemplates = () => API.get("/api/templates");
export const createTemplate = (data) => API.post("/api/templates", data);
export const updateTemplate = (id, data) =>
  API.put(`/api/templates/${id}`, data);
export const deleteTemplate = (id) => API.delete(`/api/templates/${id}`);
export const getFacebookTemplates = () =>
  API.get("/api/templates/facebook/list");

// MESSAGE APIs
export const sendTemplateMessage = (templateId, data) =>
  API.post(`/api/messages/templates/${templateId}/submit`, data);
export const getSubmissionStatus = (submitId) =>
  API.get(`/api/messages/${submitId}/status`);

// CHAT APIs
export const getChatPeers = () => API.get("/api/chat");
export const getChatMessages = (peer) => API.get(`/api/chat/${peer}`);
export const sendChatMessage = (data) => API.post("/api/chat/", data);

// Submit template to Facebook for review
export const submitTemplateToFacebook = (data) =>
  API.post("/api/templates/create", data); 

// REPORT APIs
export const getAllReports = () => API.get("/api/reports");
export const getReport = (submitId) => API.get(`/api/reports/${submitId}`);
export const getReportStats = () => API.get("/api/reports/stats");

// DASHBOARD API
export const getDashboardOverview = () => API.get("/api/dashboard/overview");

// Upload media for template creation
export const createUploadTemplateMedia = (formData) =>
  API.post(`/api/templates/upload-media`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });


// ONBOARDING API
export const getWhatsAppSignupLink = () => API.get("/api/whatsapp/generate-wa-signup-link");


// MEDIA UPLOAD for CHAT
export const uploadChatMedia = (file) => {
  const formData = new FormData();
  formData.append("media", file);

  return API.post("/api/media/uploads", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};



// MEDIA UPLOAD API for Sending Template Messages
export const uploadTemplateMedia = (templateId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return API.post(`/api/templates/${templateId}/upload-media`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};




export default API;
